import React, { useRef, useState } from 'react'
import { Grid, Typography, Stack, CircularProgress, FormHelperText, Icon, Badge } from '@mui/material';
import MDButton from 'components/MDButton';
import defaultImage from 'assets/images/placeholder-image.png';
import { grey } from '@mui/material/colors';
import MDInput from 'components/MDInput';
import { useSelector } from 'react-redux';
import { openSnackbar, uploadImage } from '../../../../redux/slices/common';
import { useDispatch } from 'react-redux';
import { openCustomModalDialog } from '../../../../redux/slices/modalSlice';

const AltImageSection = ({ validTypes, filesize, formData, setFormData, errors, ratioDesktop = '', fieldNameMobile = 'image', fieldName = "image", listingfieldName = "listingImage", isListingImage = true, isbannerImage = true, isbannerImageMobile = false }) => {
  const dispatch = useDispatch()
  const { isUploading = false, isLoading = false } = useSelector((state => state.common));
  const uploadedAtImageRef = useRef();

  const uploadThumbnailImage = {
    borderRadius: '20px',
    width: '160px',
    height: '160px',
    objectFit: 'cover',
    boxShadow: '0 0 1px rgb(0 0 0 / 20%)'
  };
  const badgeCircularProgressIcon = {
    backgroundColor: '#fff',
    borderRadius: 10,
    p: .5,
    mr: 14,
    mt: 14
  };

  const showError = (message, errortype) => {
    if (errortype === 'success') {
      dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
    }
    if (errortype === 'error') {
      dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
    }
  };
  const handleImageUpload = (e, sectionType) => {
    const file = e.target.files[0];
    uploadedAtImageRef.current = sectionType;
    if (validTypes) {
      const validTypes = ['image/jpeg', 'image/png', 'image/webp'];
      if (!validTypes.includes(file.type)) {
        showError('Only JPG, PNG, or WEBP images are allowed.','error');
        return;
      }
    }
    const MAX_FILE_SIZE = 500 * 1024; // 500KB
    if (filesize) {
      if (file.size > MAX_FILE_SIZE) {
        showError('Image size should not exceed 500 KB', 'error');
        return; // Exit the function if file is too large
      }
    }
    console.log("file",file);
    
   
    if (file) {
      const fileFormData = new FormData();
      fileFormData.append("filePath", file);
      // Dispatch the Redux action to upload the image
      dispatch(uploadImage(fileFormData))
        .unwrap()
        .then((res) => {
          const data = {
            alt: "",
            title: file?.name,
            description: "",
            url: res?.fileUrl
          }
          setFormData((prevData) => ({
            ...prevData,
            [sectionType]: data
          }));
          handleModalImage(sectionType, data)
          uploadedAtImageRef.current = null
        })
        .catch((error) => {
          uploadedAtImageRef.current = null

        })


        ;
    }
  };

  // **************************************************Media modal handle **************************************************
  const handleModalImage = (type, data, index = 0, memberSection) => {
    dispatch(openCustomModalDialog({
      modal: 'IMAGE_MODAL_SEO',
      modalData: {
        imageContent: type, data, index, memberSection, fileMediaHandler
      }
    }))
  }

  const fileMediaHandler = (mediaData, imageContent,) => {
    setFormData((prevData) => ({
      ...prevData,
      [imageContent]: mediaData
    }));
  };

  // Render image section
  const renderImageSection = (sectionType, title) => {
    return (
      <Grid item xs={6}>
        <Typography variant="body2" fontWeight="semibold" mb={1} color="#2E2E3A">{filesize ? "Banner Image (Size: 1920x1080)" : title}</Typography>
        <Stack direction='row' alignItems='center' flexWrap='wrap' gap={1.25} mb={4}>
          <Badge
            overlap='circular'
            anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
            onClick={(e) => {
              if (!formData?.[sectionType]?.url) return;
              handleModalImage(sectionType, formData?.[sectionType], 0)
            }}
            badgeContent={isUploading && uploadedAtImageRef.current === sectionType ? <CircularProgress size={32} color='primary' sx={badgeCircularProgressIcon} /> : ''}
          >
            {<img
              key={formData?.[sectionType]?.url}
              style={uploadThumbnailImage}
              src={formData?.[sectionType]?.url || defaultImage}
              alt='banner'
              className='cur-pointer'
            />}
          </Badge>
          {
            <label htmlFor={sectionType} >
              <MDButton
                sx={{ minWidth: '180px' }}
                type='button'
                variant='outlined'
                color='secondary'
                component='span'
                disabled={isUploading}
              >
                {
                  formData?.[sectionType]?.url ? 'Change Image' : 'Add Image'
                }
              </MDButton>
            </label>
          }

          <MDInput
            id={sectionType}
            type='file'
            name={sectionType}
            onChange={(e) => handleImageUpload(e, sectionType)}
            fullWidth
            disabled={isUploading}
            style={{ display: 'none' }}
          />

          {Boolean(errors?.[sectionType]) && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error>{errors?.[sectionType]}</FormHelperText>}
        </Stack>
      </Grid>
    )
  }
  return (
    <>
      <Grid container spacing={2}>
        {/* Main Image Section */}
        {isbannerImage && renderImageSection(fieldName, `Banner Desktop Image ${ratioDesktop ? ratioDesktop : ''}`)}
        {isbannerImageMobile && renderImageSection(fieldNameMobile, 'Banner Mobile Image (Size: 350x130)')}

        {/* List Image Section */}
        {isListingImage && renderImageSection(listingfieldName, 'Listing Image')}
      </Grid>
    </>
  )
}

export default AltImageSection